/* AnimatedBlueBackdrop — fondo azul con gradientes en movimiento.
   Mismo patrón visual que la sección FinalCTA: dos radial gradients
   que pannean lento (28s) + un glow central estático. */

.backdrop {
  position: absolute;
  inset: -20%;
  z-index: -2;
  background:
    radial-gradient(
      ellipse 60% 50% at 20% 30%,
      rgba(46, 108, 200, 0.12) 0%,
      transparent 60%
    ),
    radial-gradient(
      ellipse 50% 60% at 80% 70%,
      rgba(44, 168, 158, 0.10) 0%,
      transparent 55%
    ),
    var(--blue-50);
  background-size: 200% 200%;
  animation: bgPan 28s linear infinite;
  pointer-events: none;
}

.glow {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: radial-gradient(
    ellipse 50% 60% at 50% 65%,
    rgba(44, 168, 158, 0.12) 0%,
    transparent 60%
  );
  pointer-events: none;
}

@keyframes bgPan {
  0% {
    background-position: 0% 0%, 100% 100%, 0% 0%;
  }
  50% {
    background-position: 100% 50%, 0% 50%, 100% 0%;
  }
  100% {
    background-position: 0% 0%, 100% 100%, 0% 0%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .backdrop {
    animation: none;
  }
}
